import React, { useState } from 'react';
import { css, StyleSheet } from 'aphrodite';
import Grid from '@material-ui/core/Grid';
import moment from 'moment';

import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { CommonStyles } from '../../styles/Styles';
import { StatCard } from '../../common/components/StatCard';
import { AdPopFilterBar } from '../../components/AdPopFilterBar';
import { AppHelper } from '../../helpers/AppHelper';
import { Stats } from '../../components/Stats';
import { AppUiHelper } from '../../helpers/AppUiHelper';
import { ApiHelper } from '../../common/helpers/ApiHelper';
import { Toast } from '../../components/Toast';
import { Controller } from '../../common/Controller';

export class AdPopReport extends BaseEntityPage {
  pageKey = 'AdPopReport';
  pageTitle = Helper.getString('reports');
  orgId = this.props.match.params.orgId || 'PRODUCT';
  breadCrumbs = [
    { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
    { title: Helper.getString('reports') },
  ];
  noAdd = true;
  groupByOptions = [
    { key: 'DAY', value: 'DAY' },
    { key: 'HOUR', value: 'HOUR' },
    { key: 'VENUE', value: 'VENUE' },
    { key: 'CAMPAIGN', value: 'CAMPAIGN' }
  ]
  filterByOptions = [
    { key: 'NONE', value: 'NONE' },
    { key: 'VENUES', value: 'VENUES' },
    { key: 'CAMPAIGNS', value: 'CAMPAIGNS' },
  ]

  state = {
    dateStart: moment().subtract(30, 'days').format('YYYY-MM-DD'),
    dateEnd: moment().format('YYYY-MM-DD'),
    groupBy: ['DAY'],
    stats: [],
    items: [],
    filterBy: [],
    filterByValue: {},
    inProcessFilter: false,
    inProcessJob: false,
    dialogErrorMessage: '',
    showToast: false,
    severity: 'info',
    toastMsg: '',
  };

  constructor(props, options) {
    super(props, options);
    this.tableHeadersMap = {};
    this.tableHeaders = Object.keys(this.tableHeadersMap);
    this.toFetch = this.makeFetches();
  }

  makeReportRequest = (filters) => {
    return {
      method: 'GET',
      paths: ['miscs', 'revbo'],
      queryParams: this.makeReportQueryParams(filters),
    }
  }

  makeFetches = () => {
    return [this.makeReportRequest()];
  };

  makeReportQueryParams = (filters) => {
    const source = filters || this.state;
    const { dateEnd, dateStart, groupBy, filterBy, filterByValue } = source;
    const normalizedGroupBy = Array.isArray(groupBy) ? groupBy : [groupBy].filter(Boolean);
    const normalizedFilterBy = Array.isArray(filterBy) ? filterBy : [filterBy].filter((value) => value && value !== 'NONE');
    const newParam = {}
    if (normalizedFilterBy.includes('CAMPAIGNS') && filterByValue && filterByValue.CAMPAIGNS) {
      newParam.campaigns = filterByValue.CAMPAIGNS
    }
    if (normalizedFilterBy.includes('VENUES') && filterByValue && filterByValue.VENUES) {
      newParam.venues = filterByValue.VENUES
    }
    return {
      dateEnd: dateEnd.replaceAll('-', ''),
      dateStart: dateStart.replaceAll('-', ''),
      groupBy: normalizedGroupBy.join(','),
      ...newParam
    };
  };

  onFetchSuccess = (results) => {
    results[0].items.map(x => x.plays && !x.spots && (x.spots = x.plays)) // TODO: Spots added if not present.
    results[0].stats.map(x => (delete x.duration, x)) // TODO: removing duration from stats
    results[0].items.forEach((x, i) => (x.id = i)); // TODO: Added only for removing console error, because id not coming in items result.
    // Stats ------
    const statusImage = AppUiHelper.getReportsStatsImages()
    const stats = []
    for (const [key, value] of Object.entries(results[0].stats[0])) {
      if(key.toLowerCase() !== 'duration') {
        stats.push({
          title: key[0].toUpperCase() + key.slice(1),
          value: this.checkKeyForAbbr(key) ? AppHelper.abbrNum(value || 0) : value || 0,
          image: statusImage[key]
        })
      }
    }
    // Stats ------ x --
    this.setState({
      stats: stats,
      items: results[0].items,
    });
    if (results[0].items.length > 0) {
      this.tableHeadersMap = this.generateTableMap(results[0].columns);
    }
    this.export = {
      buttonTitle: 'Download',
      headers: results[0].columns,
      format: 'xlsx'
    }
  };

  fetchReportData = (filters, fromDialog) => {
    const request = this.makeReportRequest(filters)

    return new Promise((resolve) => {
      ApiHelper.call(
        request,
        function (err, data) {
          if (err) {
            const errorMessage = Helper.getErrorMsg(err)
            this.setState({
              inProcessFilter: false,
              dialogErrorMessage: fromDialog ? errorMessage : '',
              showToast: fromDialog ? false : true,
              severity: 'error',
              toastMsg: fromDialog ? '' : errorMessage
            })
            resolve(false)
            return
          }
          this.onFetchSuccess([data])
          this.setState({
            inProcessFilter: false,
            dialogErrorMessage: ''
          })
          resolve(true)
        }.bind(this)
      )
    })
  }

  createReportJob = (filters) => {
    const payload = {
      groupId: this.orgId,
      action: 'CMS_REPORT',
      ...this.makeReportQueryParams(filters)
    }

    return new Promise((resolve) => {
      ApiHelper.call({
        method: 'POST',
        endPoint: ApiHelper.makeUrlPath(['jobs']),
        jsonBody: payload,
      }, (err) => {
        if (err) {
          this.setState({
            inProcessJob: false,
            dialogErrorMessage: Helper.getErrorMsg(err)
          })
          resolve(false)
          return
        }

        this.setState({
          inProcessJob: false,
          dialogErrorMessage: ''
        })
        Controller.get().pushRoute('/admin/jobs/')
        resolve(true)
      })
    })
  }

  updateReportFilters = (filters, extraState) => {
    this.setState({
      dateStart: filters.dateStart,
      dateEnd: filters.dateEnd,
      groupBy: filters.groupBy,
      filterBy: filters.filterBy,
      filterByValue: filters.filterByValue,
      ...extraState
    })
  }

  generateTableMap = (items = {}) => {
    const map = {};
    // const map = { '#': (current) => current.__index + 1 };
    Object.keys(items).forEach((key) => {
      if (key !== 'id') {
        map[items[key]] = (current) => <div>{current[key]}</div>;
      }
    });
    return map;
  };

  onTableValue = (current, index) => {
    if (!this.tableHeaders[index]) return '';
    return this.tableHeadersMap[this.tableHeaders[index]](current);
  };

  onFilter = (filters) => {
    return new Promise((resolve) => {
      this.updateReportFilters(filters, {
        inProcessFilter: true,
      })
      this.fetchReportData(filters, filters.fromDialog).then(resolve);
    })
  };

  onCreateJob = (filters) => {
    return new Promise((resolve) => {
      this.updateReportFilters(filters, {
        inProcessJob: true,
      })
      this.createReportJob(filters).then(resolve);
    })
  }

  clearDialogError = () => {
    if (!this.state.dialogErrorMessage) return
    this.setState({
      dialogErrorMessage: ''
    })
  }

  getToast = () => {
    return (
      <Toast
        open={this.state.showToast}
        severity={this.state.severity}
        message={this.state.toastMsg}
        handleClose={() => this.setState({ showToast: false })}
      />
    )
  }

  makeFileName = () => {
    const dateEnd = this.state.dateEnd.replaceAll('-', '')
    const dateStart = this.state.dateStart.replaceAll('-', '')
    return `reports-${dateStart}-${dateEnd}`
  }

  checkKeyForAbbr = (key) => {
    const abbrKeys = ['VENUES', 'CAMPAIGNS', 'CREATIVES', 'SCREENS'];
    return !abbrKeys.includes(key.toUpperCase());
  };

  replaceSubtextString = (string) => {
    if (string.toUpperCase() === 'IMPRESSIONS') {
      return 'IMPR';
    }
    return string.toUpperCase();
  };

  renderAboveTable = () => {
    const { items, stats } = this.state;
    return (
      <div className={css(Styles.renderAboveTable)}>
        { stats && <Stats items={stats}></Stats> }
        <AdPopFilterBar
          buttonLabel={Helper.getString('filter')}
          inProcess={this.state.inProcessFilter || false}
          onFilter={this.onFilter}
          dialogApplyInProcess={this.state.inProcessFilter || false}
          dialogErrorMessage={this.state.dialogErrorMessage}
          onCreateJob={this.onCreateJob}
          dialogJobInProcess={this.state.inProcessJob || false}
          createJobButtonLabel={'Create a Job'}
          onClearDialogError={this.clearDialogError}
          dateEnd={this.state.dateEnd}
          dateStart={this.state.dateStart}
          groupBy={this.state.groupBy}
          groupByOptions={this.groupByOptions}
          filterBy={this.state.filterBy}
          filterByOptions={this.filterByOptions}
          filterByValue={this.state.filterByValue}
        />
        {this.getToast()}
      </div>
    );
  };

  onActions = () => [];
}

const Styles = StyleSheet.create({
  spanValue: {},
  img: {
    height: 30,
  },
  line2: {
    fontSize: 12,
  },
  renderAboveTable: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  circleFill: {
    width: 18,
    height: 18,
    borderRadius: '50%',
  },
  fullWidth: {
    width: '100%',
  },
  chartsContainer: {
    marginTop: '5px 0px',
    margin: '15px 0px',
    width: '100%',
  },
  eachChartHolder: {
    padding: 0,
  },
  chartBlock: {
    borderRadius: 16,
    padding: 10,
    background: '#fff',
    marginRight: 10,
    overflow: 'hidden',
    maxHeight: 240,
  },
  chartTitle: {
    marginBottom: 0,
  },
});



// WEBPACK FOOTER //
// ./src/screens/admin/AdPopReport.js